import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

// mask with regex
import MaskedInput from 'react-text-mask';

import ErrorField from '~/components/ErrorField';
import { BoxInput, Label } from './style';

const Input = ({
  label = 'Label',
  disabled,
  hasError = '',
  type = 'text',
  placeholder,
  onChange,
  value,
  name,
  mask,
  maskRegex,
  ...rest
}) => {
  return (
    <BoxInput>
      <Label>
        {label}
        {label === '1) Número do registro' && (
          <span style={{ fontSize: '0.8rem' }}>
            {' - '}
            (dentro do mês de competência)
          </span>
        )}
      </Label>

      {!mask && !maskRegex && (
        <input
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onChange}
          name={name}
          {...rest}
        />
      )}
      {mask && (
        <InputMask
          type={type}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          mask={mask}
          {...rest}
        />
      )}
      {maskRegex && (
        <MaskedInput
          type={type}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          mask={maskRegex}
          {...rest}
        />
      )}

      {hasError && <ErrorField message={hasError} />}
    </BoxInput>
  );
};

Input.propTypes = {
  label: PropTypes.string.isRequired,
  hasError: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  mask: PropTypes.string,
  maskRegex: PropTypes.arrayOf(PropTypes.any || PropTypes.instanceOf(RegExp)),
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  type: 'text',
  hasError: '',
  mask: '',
  maskRegex: null,
  disabled: false,
  placeholder: '',
};

export default Input;
export { Input };
